module.exports = __webpack_public_path__ + "img/yiyuan-name2.7a48a42d.png";